import type { RootState } from 'react-redux';

import type { ApiClient } from '@travel/api-client';
import generateLogger from '@travel/logger';

import type { SearchVacantParams, SearchVacantResponse } from 'SearchVacant-Types';

import { getSearchVacantAPI } from './api';

import { createAsyncThunk } from '@reduxjs/toolkit';

const logger = generateLogger();

type ThunkExtra = {
  apiClient: ApiClient;
  history?: any;
  req?: any;
  res?: any;
};

// Async thunk for initial fetch
export const fetchSearchVacant = createAsyncThunk<
  SearchVacantResponse,
  SearchVacantParams,
  { state: RootState; extra: ThunkExtra; rejectValue: any }
>('searchVacant/fetch', async (params, { extra, rejectWithValue }) => {
  const { apiClient } = extra;

  try {
    const response = await getSearchVacantAPI(apiClient, params);
    return response;
  } catch (error) {
    logger.error('Fetch Search Vacant Error', error);
    return rejectWithValue(error);
  }
});

// Async thunk for pagination
export const fetchMoreSearchVacant = createAsyncThunk<
  SearchVacantResponse,
  SearchVacantParams,
  { state: RootState; extra: ThunkExtra; rejectValue: any }
>('searchVacant/fetchMore', async (params, { extra, rejectWithValue }) => {
  const { apiClient } = extra;

  try {
    const response = await getSearchVacantAPI(apiClient, params);
    return response;
  } catch (error) {
    logger.error('Fetch More Search Vacant Error', error);
    return rejectWithValue(error);
  }
});
